import actionTypes from '../constants/action-types';

const disabledStatus = (state = false, action) => {
  if (action.type !== actionTypes.SET_DISABLED_STATUS) return state;
  return action.payload;
};

export default disabledStatus;
